import { useSyncExternalStore, type ReactNode } from "react";
import { appConfig } from "@/shared/config";
import { ServerInfoBadge } from "./ServerInfoBadge";
import { serverInfoController } from "./serverInfoController";
import { toServerInfoBadgeState } from "./serverInfoBadgeState";

type ServerInfoIndicatorProps = {
  collapsed: boolean;
};

// 표시 컴포넌트는 공유 스냅샷만 구독한다. 라우트 전환에도 성공값은 유지하며,
// 동시에 여러 GNB가 표시되어도 하나의 폴링 요청을 공유한다.
export function ServerInfoIndicator({ collapsed }: ServerInfoIndicatorProps): ReactNode {
  const snapshot = useSyncExternalStore(
    serverInfoController.subscribe,
    serverInfoController.getSnapshot,
    serverInfoController.getSnapshot,
  );
  return (
    <ServerInfoBadge
      state={toServerInfoBadgeState(snapshot)}
      frontendBuildId={appConfig.buildId}
      collapsed={collapsed}
    />
  );
}
